import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { selectRetailerLanguages } from '@lib/core/retailers/selectors/retailer';
import { selectRetailerLocationProductCategories } from '@lib/core/retailers/selectors/retailerLocation';
import { useApp } from '@lib/core/service/hooks';
import { setProductCategory } from '@lib/core/service/slices';
import { RouteUtils } from '@lib/tools/routes';
import { PRODUCT_CATEGORY_NONE } from '@lib/tools/shared/helpers/consts';

import { ProductCategorySelector } from '@components/pmi/src/common/ProductCategorySelector';

export const ProductCategorySelectorContainer = () => {
  const dispatch = useDispatch();
  const productCategories = useSelector(selectRetailerLocationProductCategories);
  const retailerLanguages = useSelector(selectRetailerLanguages);

  const handleSelectProductCategory = productCategoryName => {
    const supportedProductCategories = productCategories;
    const currentProductCategory = supportedProductCategories.find(product => product === productCategoryName);

    if (currentProductCategory) {
      dispatch(setProductCategory(currentProductCategory));
    }
  };

  const { route } = useApp();
  useEffect(() => {
    if (RouteUtils.getProductCategory()) {
      dispatch(setProductCategory(PRODUCT_CATEGORY_NONE));
    }
  }, [route]);

  return (
    <ProductCategorySelector
      handleSelectProductCategory={handleSelectProductCategory}
      productCategories={productCategories}
      supportedLanguages={retailerLanguages}
    />
  );
};
